import { Box, Card, Chip, getSpacing, Grid, Stack, Typography, ValidationErrors } from "@compass/core";
import { ReportPropertyIcon } from "components";
import { ReportPropertyBase } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { DisplaySnapshotMenu } from "./ExportSnapshotMenu/ExportDisplaySnapshotMenu";

export const ExportDisplayFields = (props: {
  title: string;
  exportTypeId?: number;
  exportSubTypeId?: number;
  displayFields: string[];
  setDisplayFields: (displayFields: string[]) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const [displayProperties, setDisplayProperties] = useState<ReportPropertyBase[] | undefined>();

  useEffect(() => {
    ApiService.exports.getDisplayProperties(props.exportTypeId, props.exportSubTypeId).then((response) => {
      setDisplayProperties(response);
    });


  }, []);

  return (
    <Card
      fullHeight
      header={
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing="sm">
            <Typography variant="inherit">{`${props.title} Fields`}</Typography>

          </Stack>

          <Stack direction="row" alignItems="center" spacing="sm">
            <DisplaySnapshotMenu
              displayFields={props.displayFields}
              setDisplayFields={props.setDisplayFields}
              displayProperties={displayProperties || []}
              exportTypeId={props.exportTypeId}
              exportSubTypeId={props.exportSubTypeId}
              onSelectedDisplayFields={(value) => {
                props.setDisplayFields(value);
              }}
            />
          </Stack>
        </Stack>
      }
      sx={{ height: "100%" }}
    >
      <Grid container spacing="xs">
        <Grid item xs={12}>
          <Typography color="error" >
            {props.validationErrors?.[0]}
          </Typography>
        </Grid>
        {displayProperties?.map((property, index) => {
          if (property.hidden) return null;

          const selected = props.displayFields.includes(property.identifier!);
          const isNextPropertyNewGroup = displayProperties[index + 1]?.groupBeginName;

          return (
            <>
              {property.groupBeginName && (
                <Grid item xs={12}>
                  <Typography mb={getSpacing("sm")}>{property.groupBeginName}</Typography>
                </Grid>
              )}
              <Grid item key={property.identifier}>
                <Chip
                  label={
                    <Stack direction="row" spacing="sm" alignItems={"center"}>
                      <Box>{property.displayName}</Box>
                      <ReportPropertyIcon property={property} />
                    </Stack>
                  }
                  onClick={() =>
                    props.setDisplayFields(
                      produce(props.displayFields, (draft) => {
                        const foundIndex = draft.findIndex((x) => x === property.identifier);
                        if (foundIndex !== undefined && foundIndex >= 0) {
                          draft.splice(foundIndex, 1);
                        } else {
                          draft.push(property.identifier!);
                        }
                      })!
                    )
                  }
                  variant={selected ? "filled" : "outlined"}
                  color={selected ? "success" : undefined}
                />
              </Grid>

              {isNextPropertyNewGroup && <Grid item xs={12} mb={getSpacing("md")}></Grid>}
            </>
          );
        })}
      </Grid>
    </Card>
  );
};
